<template>
  <div class="blog-dashboard-layout">
    <display-posts :divisions="divisions" :pre-fetched-posts="posts" />
  </div>
</template>

<script>
import {isEmpty} from 'lodash';

import displayPosts from './DisplayPosts.vue';
import blogTagList from './BlogTagList.vue';

export default {
  name: 'BlogDashboardLayout',

  components: {
    displayPosts,
    blogTagList,
  },

  props: {
    posts: {
      type: Array,
    },

    tags: {
      type: Array,
      required: true,
    },

    /**
     * The divisions that blog should fetch data from
     */
    divisions: {
      type: Array,
    },

    pageTitle: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isEmpty,
      meta: {},
    };
  },
};
</script>
